import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import api from '../lib/api';

export const VisitorTracker = () => {
  const location = useLocation();
  const hasTracked = useRef(false);

  useEffect(() => {
    // Only track once per session (not on every page change)
    if (hasTracked.current) return;
    
    const trackVisitor = async () => {
      try {
        const visitorData = {
          page: location.pathname,
          referrer: document.referrer || '',
          userAgent: navigator.userAgent,
          screenWidth: window.screen.width,
          screenHeight: window.screen.height,
          language: navigator.language,
          timezone: Intl.DateTimeFormat().resolvedOptions().timeZone
        };

        await api.post('/track-visitor', visitorData);
        hasTracked.current = true;
      } catch (error) {
        // Silently fail - don't break the site for tracking
        console.debug('Visitor tracking:', error.message);
      }
    };

    // Small delay to ensure page is fully loaded
    const timer = setTimeout(trackVisitor, 500);
    return () => clearTimeout(timer);
  }, [location.pathname]);

  return null; // This component renders nothing
};
